import {
  Component,
  HostBinding,
  inject,
  input,
  ViewEncapsulation,
  booleanAttribute,
  ChangeDetectionStrategy,
} from '@angular/core';
import { PageService } from '../page.service';
import { GALAXY_PAGE_OPTIONS } from '../tokens';

@Component({
  selector: 'glxy-page-toolbar',
  templateUrl: './page-toolbar.component.html',
  styleUrls: ['./page-toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageToolbarComponent {
  private readonly pageService = inject(PageService);
  private readonly pageOptions = inject(GALAXY_PAGE_OPTIONS, { optional: true });

  @HostBinding('class') class = 'glxy-page-toolbar';
  readonly showExtendedToolbar = input(false, { transform: booleanAttribute });
  readonly extendedToolbarPadding = input(true, { transform: booleanAttribute });

  // A getter, not a `computed`: @HostBinding binds the property's value, and a signal's value is the
  // function itself, which is always truthy. Bound as a computed this class was applied even when the
  // input was false, so the input did nothing for any caller.
  @HostBinding('class.extended-toolbar-has-padding')
  get hasExtendedToolbarPadding(): boolean {
    return this.extendedToolbarPadding();
  }

  readonly showNavToggle = input(this.pageService.showNavToggle ?? false);

  readonly shouldResize = input(false);

  readonly navToggleTooltip = input(this.pageService.navToggleTooltip);

  toggleNav(): void {
    this.pageOptions?.toggleNav();
    if (this.shouldResize()) {
      window.dispatchEvent(new Event('resize'));
    }
  }
}
